import '../App.css';
import React, { useEffect, useRef, useState } from 'react';

import { Auth, Hub } from 'aws-amplify';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { intAmplify } from '../aws-amplify-init';
import AuthorizationView from './AuthorizationView';
import { API_ENDPOINTS } from '../utils/UrlUtils';
import { ManageUsersService } from "../components/manage_users/service/ManageUserService";
import moment from 'moment'
import { invokePostApi } from '../utils/api';
import { UploadQueueContextProvider } from "./referral_list/upload/UploadQueueContextApi";
import { HttpStatusCode } from 'axios';
import { TEXT } from './custom_authentication/CustomAuthUtils';
import { Toast } from 'primereact/toast';

function MainView() {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [amplifyStatus, setAmplifyStatus] = useState({
        status: searchParams.get("success") ? 'SIGN-IN' : 'UNKNOWN',
        apiConfig: null
    });
    const [userAgreement, setUserAgreement] = useState(null);
    const isAmplifyInitialized = useRef(false);
    const toast = useRef(null);
    const signOut = async (sessionTimeout) => {
        try {
            // Handle session timeout if applicable
            if (sessionTimeout) {
                const { statusCode } = await invokePostApi(API_ENDPOINTS.SESSION_TIMEOUT);
                if (statusCode !== HttpStatusCode.Ok) {
                    displayToastMessage(TEXT.ERROR, TEXT.ERROR_GENERIC);
                    return false;
                }
            }
            // Notify backend of logout
            const { statusCode } = await invokePostApi(API_ENDPOINTS.LOGOUT);
            if (statusCode !== HttpStatusCode.Ok) {
                throw new Error('Logout failed');
            }
            // Proceed with sign out
            await Auth.signOut();
            setUser(null);
            setAmplifyStatus({ status: 'Logout', apiConfig: undefined });

            return true;
        } catch (error) {
            console.error('SignOut error:', error);
            displayToastMessage(TEXT.ERROR, TEXT.LOGOUT_ERROR);
            return false;
        }
    };


    const displayToastMessage = (severity, message) => {
            let errorClass= severity === TEXT.ERROR ? TEXT.FAILURE_TOAST : TEXT.SUCCESS_TOAST;
            let toastMessage = {
                severity: severity,
                life: 3000,
                summary : message,
                className : errorClass
            }
            toast.current.show(toastMessage);
        };

    useEffect(() => {
    if (["SIGN-IN", "ERROR"].includes(amplifyStatus.status)) {
      navigate("/signin");
    }
  }, [amplifyStatus.status, navigate]);

    useEffect(() => {
        if (!isAmplifyInitialized.current) {
            isAmplifyInitialized.current = true;
            intAmplify().then((response) => {
                try {
                    Auth.currentAuthenticatedUser()
                        .then((userData) => {
                            setUser(userData);
                            setAmplifyStatus({
                                status:
                                    'INITIALIZED',
                                apiConfig: response.apiConfig
                            });

                            const user_id = userData['username'] //userData.signInUserSession.idToken.payload['email']
                            ManageUsersService.getUserAgreement(user_id).then((response) => {
                                if (response && response.statusCode === HttpStatusCode.Ok) {
                                    setUserAgreement(response.data)
                                }else{
                                    displayToastMessage(TEXT.ERROR, TEXT.USER_AGREEMENT_FETCH_FAIL)
                                }
                            })
                        })
                        .catch(() => {
                            if (searchParams.get("success")) {
                                navigate('/signin')
                            } else {
                                navigate('/login')
                            }
                        });
                    listenAmplifyEventListener(response.apiConfig);

                } catch (error) {
                    setAmplifyStatus({
                        status:'ERROR',
                        apiConfig: undefined
                    })
                }
            }).catch((err) => {
                setAmplifyStatus({
                    status:'ERROR',
                    apiConfig: undefined
                })
            });
        }
        const listenAmplifyEventListener = (apiCfg) => {
            
            Hub.listen('auth', ({ payload: { event, data } }) => {
                switch (event) {
                    case 'signIn':
                        break;
                    case 'cognitoHostedUI':
                        invokePostApi(API_ENDPOINTS.LOGIN, {
                            "login_date": moment().utc().format('MM/DD/YYYY'),
                            "user_id": data.username
                        });
                        break;
                    case 'signOut':
                        setUser(null);
                        break;
                    case 'signIn_failure':
                    case 'cognitoHostedUI_failure':
                        console.log('Sign in failure', data);
                        break;
                    default:

                }
            });
        }
    }, [navigate,searchParams]);


    return (
        <>
        <Toast ref={toast} position='top-center' />
        {userAgreement && user && amplifyStatus.apiConfig ? (
            <UploadQueueContextProvider apiConfig={amplifyStatus.apiConfig}>
                <AuthorizationView amplifyStatus={amplifyStatus} signOut={signOut} user={user} userAgreement={userAgreement} setUserAgreement={setUserAgreement}></AuthorizationView>
            </UploadQueueContextProvider>
        ) : (
            <div className='buttons-holder'>
                Loading the Covera Provider Portal. Please wait...<br />
            </div>
        )}
        </>
    );
}

export default MainView;
